import * as yup from 'yup';
import { BARCODE_TYPES } from 'library/constants/models/item';

export const getUpdatedValues = (dirtyFields, values) => {
  if (dirtyFields === true || Array.isArray(dirtyFields)) {
    return values;
  }
  const extraFields = {};

  const result = Object.fromEntries(
    Object.keys(dirtyFields).map((key) => {
      if (['tags'].includes(key)) {
        return ['tags_ids', getUpdatedValues(dirtyFields[key], values[key]).reduce((ids, { value: id }) => {
          if(Number.isInteger(id)) {
            return [...ids, id];
          }

          if(!extraFields.new_tags) {
            extraFields.new_tags = [];
          }

          extraFields.new_tags.push(id);

          return ids;
        }, [])];
      }

      if (['sets'].includes(key)) {
        return ['sets_ids', getUpdatedValues(dirtyFields[key], values[key]).map((id) => id)];
      }

      if (['images'].includes(key)) {
        const updatedValues = getUpdatedValues(dirtyFields[key], values[key]);
        const primaryImage = updatedValues.find(({ isPrimary }) => isPrimary === true);

        if(primaryImage) {
          extraFields.primaryImage = primaryImage;
        }

        return ['image_ids', getUpdatedValues(dirtyFields[key], values[key]).map(({ id }) => id)];
      }

      if (key === 'price') {
        const val = getUpdatedValues(dirtyFields[key], values[key]);

        return [key, !Number.isNaN(parseFloat(val)) ? parseFloat(val) : null];
      }

      if (key === 'note') {
        const val = getUpdatedValues(dirtyFields[key], values[key]);

        return [key, typeof val === 'string' ? val.trim() : null];
      }

      if (key === 'count') {
        const val = getUpdatedValues(dirtyFields[key], values[key]);
        return [key, Number.isInteger(parseInt(val, 10)) ? parseInt(val, 10) : undefined];
      }

      if (key === 'category') {
        const val = getUpdatedValues(dirtyFields[key], values[key]);
        return ['category_id', Number.isInteger(val) ? val : undefined];
      }

      if (key === 'barcode') {
        if(values[key].length >= 13) {
          extraFields.barcode_type = BARCODE_TYPES.UPC;
        } else {
          extraFields.barcode_type = BARCODE_TYPES.EAN;
        }

        return ['barcode', values[key]];
      }

      if (key === 'manufacturer') {
        const val = getUpdatedValues(dirtyFields[key], values[key]);

        if(Number.isInteger(val)) {
          return ['manufacturer_id', Number.isInteger(val) ? parseFloat(val) : undefined];
        }

        if(typeof val === 'string') {
          extraFields.new_manufacturer = val;
        }

        return ['manufacturer_id', undefined];
      }

      if (key === 'storage') {
        const val = getUpdatedValues(dirtyFields[key], values[key]);

        if(Number.isInteger(val)) {
          return ['storage_id', val];
        }

        if(typeof val === 'string') {
          extraFields.new_storage = val;
        }

        return ['storage_id', undefined];
      }

      return [key, getUpdatedValues(dirtyFields[key], values[key])];
    }),
  );

  return {
    ...result,
    ...extraFields,
  };
};

export const format = ({
  dirtyFields,
  values: { storage_id, ...values },
}) => ({ ...getUpdatedValues(dirtyFields, values) });

export const ITEM_VALIDATION = yup.object().shape({
  name: yup.string()
    .required('Name is required'),
  // tags: yup.array().of(yup.mixed()).default([]),
  tags: yup.array().of(yup.object().shape({
    value: yup.mixed().required(),
  })).default([]),
  sets: yup.array().of(yup.number().required()).default([]),
  category: yup.number().optional().nullable(),
  manufacturer: yup.mixed().optional().nullable(),
  images: yup.array().of(yup.object().shape({
    id: yup.number().required(),
    url: yup.string().required(),
    isNew: yup.boolean().notRequired(),
    created_at: yup.string().notRequired(),
  })).default([]),
  colors: yup.array().of(yup.string().required()).default([]).test(
    'mustDifferFromDefaultValue',
    'Colors value wasn\'t changed',
    (value, { originalValue }) => {
      return originalValue.sort().toString() === value.sort().toString();
    },
  ),
  count: yup.mixed().test(
    'maxDigitsAfterDecimal',
    'number field must have 2 digits after decimal or less',
    (value) => {
      if (value === '') {
        return true;
      }

      return /^\d+?$/.test(value);
    },
  ).notRequired(),
  storage: yup.mixed().optional().nullable(),
  barcode: yup.string()
    // .min(12, 'Barcode is too short')
    // .max(13, 'Barcode is too long')
    .optional()
    .default(null),
  price: yup.mixed().test(
    'maxDigitsAfterDecimal',
    'number field must have 2 digits after decimal or less',
    (value) => {
      if (value === '') {
        return true;
      }

      return /^\d+(\.\d{1,2})?$/.test(value);
    },
  ).notRequired(),
  note: yup.string().optional().default(null),
  is_wishlisted: yup.boolean().default(false).nullable(),
  new_tags: yup.array().of(yup.number()).default([]),
});

export const getBatchAddEntities = (data = {}) => Object.keys(data).reduce((result, key) => {
  if(Array.isArray(data[key]) && data[key].length === 0) {
    return result;
  }
  return {
    ...result,
    [key]: data[key],
  };
}, {});
